/**
 * Separate exhibition event filter from other filters
 * Exhibition event filters use whereEvents parameter in GraphQL query
 * while other filters use regular where parameter
 */
export const separateFilters = (filterObj) => {
    if (!filterObj) return { where: null, whereEvents: null };

    let whereEvents = null;

    const processFilter = (filter) => {
        if (Array.isArray(filter)) {
            return filter.map(processFilter);
        }

        if (filter.AND) {
            const processedAnd = filter.AND.map(processFilter).filter(Boolean);
            return processedAnd.length > 0 ? { AND: processedAnd } : null;
        }

        // Check if this is an exhibition event filter
        if (filter.column === 'TITLE' && filter.operator === 'LIKE') {
            whereEvents = filter;
            return null; // Remove from regular where clause
        }

        return filter;
    };

    const processedWhere = processFilter(filterObj);

    return {
        where: processedWhere,
        whereEvents: whereEvents
    };
};

const GraphicStandFilterHelper = {
    separateFilters
};

export default GraphicStandFilterHelper;
